module.exports = __webpack_public_path__ + "img/instructor_img9.868ce78f.png";